import React, { FC, useState, useContext, useEffect, useRef, Fragment } from "react";
import axios from "axios";
import { API_URL } from "api/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "context/userContext";
import { TrashIcon } from "@heroicons/react/24/solid";
import { Popover, Transition, Dialog } from "@headlessui/react";
import { formatToTimeZone } from "./ListingImageGallery/utils/formatToTimeZone";

export interface DiscountPopoverProps {
  showPopover: boolean;
  setShowPopover: any;
  // discount: any;
  // setDiscount: any;
  data: any;
  updatedPrice?: number;
  setUpdatedPrice?: any;
  expiry: any;
  deal_id?:any;
  deal_amount?:any;
}

const DiscountPopover: FC<DiscountPopoverProps> = ({
  showPopover,
  setShowPopover,
  // discount,
  // setDiscount,
  data,
  updatedPrice,
  setUpdatedPrice,
  expiry,
  deal_id,
  deal_amount
}) => {
  const token = localStorage.getItem("token");
  const authContext = useContext(AuthContext);
  const { getOwnerProperty } = authContext;
  const [cancelDealModal, setCancelDealModal] = useState(false);
  const [validationError, setValidationError] = useState<string>("");

  // Validation function for discount price
  const validateDiscountPrice = (price: number): string => {
    if (price <= 0) {
      return "Discount price must be greater than 0";
    }
    if (price >= data.price) {
      return "Discount price must be less than original price";
    }
    return "";
  };

  // const formattedExpiry = (expiry: any) => {
  //   if (!(expiry instanceof Date)) expiry = new Date(expiry);
  //   const options: Intl.DateTimeFormatOptions = {
  //     weekday:"long",
  //     hour: "numeric",
  //     minute: "numeric",
  //     hour12: true,
  //   };
  //   return ` ${expiry?.toLocaleString("en-US", options)}`;
  // };

//   useEffect(() => {
//     setUpdatedPrice(discount);
// }, [updatedPrice, discount]);

  const popoverRef = useRef<HTMLDivElement>(null);

  // Close popover when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
        setShowPopover(false);
      }
    };

    if (showPopover) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopover]);
 

  const handleSave = async () => {
    // Validate before saving
    if (!updatedPrice) {
      setValidationError("Please enter a discount price");
      toast.error("Please enter a discount price");
      return;
    }
    
    const error = validateDiscountPrice(updatedPrice);
    if (error) {
      setValidationError(error);
      toast.error(error);
      return;
    }

    try {
      setShowPopover(false);
      if( deal_id && deal_amount ){
        const response = await axios.put(`${API_URL}/owner/${data._id}/edit-deal`, { discountValue: updatedPrice,deal_id: deal_id }, {headers: {token: token}});
        if (response.data.error === true) {
          toast.warn(`${response.data.message}`);
        }else{
          toast.success(`${response.data.message}`);
        }
      }else{
        const response = await axios.put(`${API_URL}/owner/${data._id}/deal`, { discountValue: updatedPrice }, {headers: {token: token}});
        if (response.data.error === true) {
          toast.warn(`${response.data.message}`);
        }else{
          toast.success(`${response.data.message}`);
        }
      }
      // setDiscount(discount)
      window.location.reload();
      setUpdatedPrice(updatedPrice);
      
    } catch (error) {
      console.error("Error setting deal:", error);
    }
  };

  const handleDeleteClick = () => {
    setCancelDealModal(true);
  }

  const confirmCancelDeal = async () => {
    setCancelDealModal(false);
    try {
      const response = await axios.delete(`${API_URL}/owner/${data._id}/cancel-deal`, {
        headers: {
          token: token,
        },
      });
      if (response.data.error === false) {
        toast.success(`${response.data.message}`);
        setUpdatedPrice(data.price);
      }
      window.location.reload();
      getOwnerProperty();
    } catch (error) {
      toast.error("Failed to remove last minute deal");
    }
  };
  
  return (
    <>
      {showPopover && (
        <div
        ref={popoverRef}
        className="absolute bg-white border shadow-lg p-4 rounded-md top-20 right-0 w-full">
          <div className="flex justify-between mb-2">
            <label className="block text-xs font-medium">Last Minute Deal</label>
          <button onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleDeleteClick();
          }} >
            {deal_amount ? <TrashIcon className="w-4 h-4 text-neutral-700" /> : ""}
          </button>
          </div>
          
          <input
            type="Number"
            value={updatedPrice}
            onChange={(e: any) => {
              const newPrice = parseFloat(e.target.value);
              setUpdatedPrice(newPrice);
              
              // Validate the new price
              const error = validateDiscountPrice(newPrice);
              setValidationError(error);
            }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            placeholder="Enter new price"
            className={`border rounded-md px-2 py-1 w-full mt-1 bg-white text-xs ${
              validationError ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {validationError && (
            <p className="text-xs text-red-500 mt-1">
              {validationError}
            </p>
          )}
          {/* {expiry && new Date(expiry).getTime() < new Date().getTime() ? (
             <p className="text-xs text-neutral-700 mt-3 text-red-500">
             Deal Expired !
           </p>
          ) : discount > 0 &&  (
            <p className="text-[12px] text-neutral-700">
              {` Deal Expiry : ${formatToTimeZone(expiry)}`}
            </p>
            
          ) } */}
          
          <button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handleSave();
            }}
            disabled={!!validationError}
            className={`mt-2 px-3 py-1 rounded-md w-full text-sm ${
              validationError 
                ? 'bg-gray-400 text-gray-200 cursor-not-allowed' 
                : 'bg-custom-color text-white hover:bg-opacity-90'
            }`}
          >
            Save Deal
          </button>
        </div>
      )}
      {/* REMOVE LAST MINUTE DEAL MODAL */}
       <Transition show={cancelDealModal} as={Fragment}>
              <Dialog
                as="div"
                className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
                onClose={() => setCancelDealModal(false)}
              >
                <Dialog.Panel className="bg-white dark:bg-gray-900 p-6 rounded-lg max-w-lg w-full shadow-xl">
                  <Dialog.Title className="text-md font-semibold text-center">
                    Confirm cancel last minute deal
                  </Dialog.Title>
                  <p className="text-sm text-gray-600 dark:text-gray-400 text-center mt-2">
                    Are you sure you want to remove last minute deal? This action cannot
                    be undone.
                  </p>
                  <div className="mt-4 flex justify-center gap-4">
                    <button
                      onClick={() => setCancelDealModal(false)}
                      className="px-4 py-2 bg-gray-300 dark:bg-gray-700 rounded-md text-sm"
                    >
                      No, Cancel
                    </button>
                    <button
                      onClick={confirmCancelDeal}
                      className="px-4 py-2 bg-red-600 text-white rounded-md text-sm"
                    >
                      Yes, Remove Deal
                    </button>
                  </div>
                </Dialog.Panel>
              </Dialog>
            </Transition>
    </>
  );
};

export default DiscountPopover;
